<template>
  <div>
    <div id="gateone_container">
      <div id="gateone">
      </div>
    </div>
  </div>
</template>
<script>
import './gateone'
import { getRemoteLink, getRemoteLinks, closeRemote } from '@/api/gateone'
import { remgateone } from '@/cookie/cookie'
// GateOne.init({url: 'https://10.10.11.13'});
export default {
  data() {
    return {
      did: this.$route.params.id,
      settime: null,
      url: 'https://' + document.domain + ':8000' + '/',
      autoConnectURL: null
    }
  },
  mounted() {
    this.getRemoteLink()
    // console.log('GateOne数据',this.$route.params)
  },
  methods: {
    //页面关闭事件
    beforeunloadFn(e) {
      e = e || window.event;
      if (e) {
        let data = new FormData()
        closeRemote(this.did)
          .then((res) => {
          })
        e.returnValue = this.$t('lang.gateone.closeTips');
      }
      return this.$t('lang.gateone.closeTips');
    },
    //获取port参数
    async getRemoteLink() {
      // await closeRemote(this.did)
      getRemoteLink(this.did)
        .then((res) => {
          if (res.data.code == 0) {
            this.autoConnectURL = `ssh://root@127.0.0.1:${parseInt(res.data.data.port)}`;
          } else if (res.data.code === 31) { //如果获取成功
            this.$message({
              showClose: true,
              message: this.$t('lang.gateone.isUsed'),
              type: 'warning',
              duration: 0
            });
          }
          if (res.data.code === 0) {
            //启动定时器
            this.settime = setInterval(() => {
              getRemoteLinks(this.did).then((res) => {
                //建立成功跳转gateone页面并且删除定时
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('lang.gateone.successConect'),
                    type: 'success'
                  });
                  window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
                  //清除gateone缓存
                  localStorage.removeItem("go_default_USN");
                  localStorage.removeItem("go_default_bookmarks");
                  localStorage.removeItem("go_default_deletedBookmarks");
                  localStorage.removeItem("go_default_iconQueue");
                  localStorage.removeItem("go_default_logs_sort");
                  localStorage.removeItem("go_default_prefs");
                  localStorage.removeItem("go_default_selectedTerminal");
                  localStorage.removeItem("go_default_selectedWorkspace");
                  localStorage.removeItem("go_default_sort");
                  remgateone()
                  GateOne.init(
                    {
                      url: this.url,
                      showToolbar: false,
                      autoConnectURL: this.autoConnectURL,
                      goDiv: '#gateone',
                    }
                  );
                  window.clearInterval(this.settime)
                } else if (res.data.code === 1) { //建立失败继续建立
                  this.$message({
                    showClose: true,
                    message: this.$t('lang.gateone.failConnect'),
                    type: 'error'
                  });
                } else if (res.data.code === 26) {//建立失败继续建立
                  this.$message({
                    showClose: true,
                    message: this.$t('lang.gateone.connecting'),
                    type: 'warning'
                  });
                }
              })
            }, 3000)
          }
        })
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  }
}
</script>

<style scoped></style>
